export const checkProductType = (productType) => {    
    
    return productType == 2 ? 'producto' : 'comic'
};